<template>
  <router-view />
</template>

<script>
import storage from 'key-storage';
import { mapGetters } from 'vuex';

export default {
  name: 'app',
  created() {
    this.$i18n.locale = storage.get('i18n', 'gt');
  },
  computed: {
    ...mapGetters([
      'country'
    ])
  },
  watch: {
    country(val) {
      this.$i18n.locale = val;
    }
  }
};
</script>

<style lang="scss">
  @import './src/assets/styles/app.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue